import DIcon from '@components/DIcon.vue';

export default {
  components: {
    DIcon,
  },

  props: {
    /**
     * Adding title text will automatically change this to a titled message.
     */
    title: String,

    /**
     * Show an icon in the Message Body based on the type selected.
     */
    hasIcon: {
      type: Boolean,
      default: false,
    },

    /**
     * Sets the background color, text color and icon (if applicable). Can be left empty for a neutral background.
     * `info, success, warning, error`
     */
    type: {
      type: String,
      default: null,
      validator: value => [null, 'info', 'success', 'warning', 'error'].includes(value),
    },

    /**
     * Persist the alert with `active` or act as a v-model with `active.sync`.
     */
    active: {
      type: Boolean,
      default: true,
    },

    /**
     * Sets a timeout to close the Message.
     */
    autoClose: {
      type: Boolean,
      default: false,
    },

    /**
     * Milliseconds that the Message is open. Only used when `autoClose` is enabled.
     */
    duration: {
      type: Number,
      default: 2000,
    },

    /**
     * Specifies that the Message can be closed. Must have a `title` to show a close button.
     */
    closable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isActive: this.active,
    };
  },

  watch: {
    active(value) {
      this.isActive = value;
    },

    isActive(value) {
      if (value) {
        this.setAutoClose();
      } else if (this.timer) {
        clearTimeout(this.timer);
      }
    },
  },

  computed: {
    /**
     * Icon name (MDI) based on type.
     */
    icon() {
      switch (this.type) {
        case 'info':
          return 'information';
        case 'success':
          return 'check-circle';
        case 'warning':
          return 'alert';
        case 'error':
          return 'alert-circle';
        default:
          return null;
      }
    },
  },

  methods: {
    /**
     * Close the Message and emit events.
     */
    close() {
      this.isActive = false;

      /**
       * Notifies the Message has started closing.
       */
      this.$emit('close');

      /**
       * Notifies the active prop of being closed. You will need to use `active.sync` to see this result.
       * @type {boolean}
       */
      this.$emit('update:active', false);
    },

    /**
     * Set timer to auto close message
     */
    setAutoClose() {
      if (this.autoClose) {
        this.timer = setTimeout(() => {
          if (this.isActive) {
            this.close();
          }
        }, this.duration);
      }
    },
  },

  mounted() {
    this.setAutoClose();
  },
};